import type { GetCoursesSortBy } from './getCoursesSortBy';
import type { GetCoursesSortOrder } from './getCoursesSortOrder';
import type { GetCoursesFilterByLevel } from './getCoursesFilterByLevel';
import type { GetCoursesType } from './getCoursesType';
import type { GetCoursesStatus } from './getCoursesStatus';

export type GetCoursesParams = {
/**
 * 페이지 번호 (0부터 시작)
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
/**
 * 정렬 기준 필드
 */
sortBy?: GetCoursesSortBy;
/**
 * 정렬 순서 (ASC 오름차순, DESC 내림차순)
 */
sortOrder?: GetCoursesSortOrder;
/**
 * 강의 레벨 필터
 */
filterByLevel?: GetCoursesFilterByLevel;
/**
 * 조회할 강의의 타입을 지정합니다.
- `USER`: 특정 사용자가 생성한 모든 강의 (초안 포함 가능성 있음, 강사 입장)
- `ENROLLED`: 특정 사용자가 수강 신청한 강의 (수강생 입장)
- `POPULAR`: 인기 강의
- `ROADMAP`: 특정 로드맵에 속한 강의
- `FORYOU`: 사용자 맞춤 추천 강의
- `MY_PUBLISHED`: 현재 로그인한 사용자가 게시한 강의 (게시된 강의만, 강사 입장)

 */
type?: GetCoursesType;
/**
 * type이 User일 경우, 조회할 사용자의 ID
 */
userId?: string;
/**
 * 강의 완료 상태로 필터링 (completed - 완료된 강의, in-progress - 수강 중인 강의)
 */
status?: GetCoursesStatus;
/**
 * 특정 로드맵에 속한 강의만 필터링
 */
roadmapId?: number;
/**
 * 검색할 키워드 (강의 제목, 설명 등 대상)
 */
searchTerm?: string;
};
